<template>
  <BaseChart ref="baseChart" :options="options" />
</template>

<script>
import BaseChart from '@@/common/stats/BaseChart';

export default {
  name: 'CampaignStatsOverallChartContent',

  components: {
    BaseChart,
  },

  props: {
    stats: {
      type: Object,
      required: true,
    },
    chartsVisibility: {
      type: Object,
      required: true,
    },
    seriesColors: {
      type: Array,
      required: true,
    },
  },

  computed: {
    seriesInstallCounts() {
      return this.stats.stats?.map(item => item.count);
    },
    seriesCostsPerInstall() {
      return this.stats.stats?.map(item => item.costPerInstall);
    },
    seriesDates() {
      return this.stats.stats?.map(item => item.date);
    },
    series() {
      return [
        {
          yAxis: 1,
          name: this.$t('ADVERTISEMENT.CAMPAIGNS.BASIC.INSTALLS_COUNT'),
          data: this.seriesInstallCounts,
        },
        {
          name: this.$t('ADVERTISEMENT.BASIC_ADS.STATS.PAYMENT_PER_INSTALL'),
          data: this.seriesCostsPerInstall,
        },
      ];
    },
    options() {
      return {
        chart: {
          height: '300',
        },
        xAxis: {
          categories: this.seriesDates,
        },
        colors: this.seriesColors,
        yAxis: [
          {
            labels: {
              style: {
                color: this.seriesColors[1],
              },
            },
            title: false,
          },
          {
            title: false,
            labels: {
              style: {
                color: this.seriesColors[0],
              },
            },
            opposite: true,
          },
        ],
        legend: false,
        title: false,
        series: this.series,
      };
    },
  },

  watch: {
    chartsVisibility: {
      deep: true,
      handler() {
        const chart = this.$refs.baseChart.getChart();

        Object.values(this.chartsVisibility).forEach((isVisible, index) => {
          if (isVisible) {
            chart.series[index].show();
            return;
          }
          chart.series[index].hide();
        });
      },
    },
  },
};
</script>
